module.exports = __webpack_public_path__ + "img/photo-analysis-article-icon-orange.0d8e9df7.svg";